import toast from "react-hot-toast";
import ProductImage from "../../common/ProductImage";
import EditButton from "../../common/EditButton";
import ViewButton from "../../common/ViewButton";
import DeleteButton from "../../common/DeleteButton";
import { Form } from "react-bootstrap";
import CheckPermission from "../../roles/CheckPermission";
import { privateApi } from "../../../api";

const ProjectListBox = ({
      loading,
      projects,
      loadData,
      setProjects,
      setLoading,
}) => {
      const handleStatus = async (project) => {
            await privateApi
                  .post(`/dashboard/projects/${project.slug}/status`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (project) => {
            const response = await privateApi
                  .delete(`/dashboard/projects/${project.slug}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setProjects((projects) =>
                                    projects.filter(
                                          (item) => item.id !== project.id
                                    )
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <thead>
                        <tr>
                              <th>#</th>
                              <th>Title</th>
                              <th>Location</th>
                              <th width="80px">Status</th>
                              <th width="120px">Action</th>
                        </tr>
                  </thead>

                  <tbody>
                        {!loading ? (
                              projects?.length > 0 ? (
                                    projects?.map((project, index) => (
                                          <>
                                                <tr key={index}>
                                                      <td>{project.index}</td>
                                                      <td>
                                                            <ProductImage
                                                                  title={
                                                                        project.title
                                                                  }
                                                                  image={
                                                                        project.image
                                                                  }
                                                            />
                                                      </td>
                                                      <td>
                                                            {project.location}
                                                      </td>
                                                      <td className="text-center">
                                                            <Form.Check
                                                                  type="switch"
                                                                  defaultChecked={
                                                                        project.status ===
                                                                        1
                                                                              ? true
                                                                              : false
                                                                  }
                                                                  onClick={() =>
                                                                        handleStatus(
                                                                              project
                                                                        )
                                                                  }
                                                            />
                                                      </td>
                                                      <td className="text-center">
                                                            <EditButton
                                                                  link={`/dashboard/projects/${project.slug}/edit`}
                                                            />
                                                            <ViewButton
                                                                  link={`/dashboard/projects/${project.slug}/show`}
                                                            />
                                                            <CheckPermission permission="project-delete">
                                                                  <DeleteButton
                                                                        item={
                                                                              project
                                                                        }
                                                                        loading={
                                                                              loading
                                                                        }
                                                                        setLoading={
                                                                              setLoading
                                                                        }
                                                                        handleDelete={
                                                                              handleDelete
                                                                        }
                                                                  />
                                                            </CheckPermission>
                                                      </td>
                                                </tr>
                                          </>
                                    ))
                              ) : (
                                    <>
                                          <tr>
                                                <td
                                                      colSpan={8}
                                                      className="text-center"
                                                >
                                                      No Project Found
                                                </td>
                                          </tr>
                                    </>
                              )
                        ) : (
                              <>
                                    <tr>
                                          <td
                                                colSpan={8}
                                                className="text-center"
                                          >
                                                Loading...
                                          </td>
                                    </tr>
                              </>
                        )}
                  </tbody>
            </>
      );
};

export default ProjectListBox;
